export default {
// vi-VN.js
help: {
  faq: "Câu hỏi thường gặp",
  promo: "Khuyến mãi",
  contactUs: "Liên hệ chúng tôi",
  joinCommunity: "Tham gia cộng đồng của chúng tôi",
  help: "Trợ giúp"
}
};
